



















import Vue from 'vue';
export default Vue.extend({
  name: 'StudioLogo',
  props: {
    studio: {
      type: Object,
      required: true,
    },
  },
});
